import { render, staticRenderFns } from "./JiuzhengPl.vue?vue&type=template&id=4ecc8eae&scoped=true"
import script from "./JiuzhengPl.vue?vue&type=script&lang=js"
export * from "./JiuzhengPl.vue?vue&type=script&lang=js"
import style0 from "./JiuzhengPl.vue?vue&type=style&index=0&id=4ecc8eae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecc8eae",
  null
  
)

export default component.exports